$(document).ready(function () {
  $('.owl-carousel').owlCarousel({
    center: true,
    loop: true,
    margin: 100,
    autoplay: true,
    autoplayTimeout: 8000,
    slideTransition: 'Ease',
    smartSpeed: 1000,
    dotsContainer: '#owl-dots-custom',
    responsive: {
      0: {
        items: 1,
      },
      1030: {
        items: 3,
      },
    },
  });
});
